import {
  getSymbolLibraryAssets,
  type LibrarySymbolAsset,
} from "../../../components/Views/SymbolLibraryTabs";

const ARCHITECTURE_SYMBOL_KEY = /^(FLOOR_PLAN|MANUAL)\//;
const EXCLUDED_CATEGORIES = new Set(["Wall Attachments", "Stairs"]);

/** Floor-plan furniture symbols available as 2D icons for uploaded 3D objects. */
export const getUserModelArchitectureSymbolOptions = (): LibrarySymbolAsset[] =>
  getSymbolLibraryAssets("FLOOR_PLAN").filter(
    (asset: LibrarySymbolAsset) =>
      ARCHITECTURE_SYMBOL_KEY.test(asset.id) &&
      !EXCLUDED_CATEGORIES.has(asset.category),
  );
